import jQuery from 'jquery';

window.$ = window.jQuery = jQuery;

window.require = window.require || function (name) {
  if (name === 'jquery') {
    return window.jQuery;
  }

  return {};
};

export default jQuery;
